const importWizard = {
  steps: {
    upload: "Upload",
    parse: "Preview and columns",
    columns: "Details and access",
    confirm: "Confirm",
  },
  delimiters: {
    comma: "Comma",
    semicolon: "Semicolon",
    tab: "Tab",
    other: "Other",
  },
  pii: {
    ariaLabel: "Likely personal data: {{reasons}}",
    tooltipHeading: "Likely personal data because:",
  },
  upload: {
    readingFile: "Reading file…",
    clickOrDrag: "Click to select or drag a file here",
    fileTypesHint: "CSV, TSV, TXT, XLSX, or SAS7BDAT · max 50 MB",
  },
  parse: {
    delimiterLabel: "Delimiter",
    optionsLabel: "Options",
    customDelimiterAriaLabel: "Custom delimiter character",
    customDelimiterTitle: "Type the single character that separates columns",
    headerRowLabel: "First row is header",
    sheetsListLabel: "Sheets in this workbook",
    sheetMeta: "{{rows}} rows · {{columns}} cols",
    storeAsLabel: "Store this upload as",
    storeAsWorkbookOption:
      "Excel workbook — every sheet, formatting and formula preserved; download hands back a real .xlsx.",
    storeAsCsvOption: "Flatten to standard CSV to enable more querying options.",
    sasHint: "SAS dataset — columns detected automatically from file metadata.",
  },
  preview: {
    label: "Preview",
    caption:
      "{{columnCount}} columns detected · showing first {{shown}} of {{total}} rows",
  },
  columns: {
    datasetNameLabel: "Dataset name",
    datasetNamePlaceholder: "e.g. Cardiology intake 2026",
    piiPreselectedBanner_one:
      "{{count}} column pre-selected by automatic personal-data detection. Hover ? to see why, and uncheck it if it isn't actually personal data.",
    piiPreselectedBanner_other:
      "{{count}} columns pre-selected by automatic personal-data detection. Hover ? to see why, and uncheck any that aren't actually personal data.",
    pickerLabel: "Columns to pseudonymize",
    noneSelectedTitle: "Select at least one column to pseudonymize",
    requestedBadgeTitle: "Originally requested",
    deidentifiedCaption:
      "{{selected}} of {{total}} columns will be pseudonymized",
    selfUploadNotice: "This file will be visible and downloadable only by you.",
    datasetExpiryLabel: "Dataset expiry",
    datasetExpiryHint:
      "Leave blank for no expiry. If set, the dataset is permanently destroyed after this date.",
    descriptionLabel: "Description (optional)",
    descriptionPlaceholder: "What this dataset contains and anything worth knowing about it",
    reviewAndConfirmButton: "Review and confirm",
    piiBlockedTitle: "Review the PII findings and confirm before continuing",
  },
  confirm: {
    removedLabel: "Removed",
    pseudonymizedLabel: "Pseudonymized",
    explanationCaption:
      "Removed columns are dropped entirely. Pseudonymized columns stay in the file, but their values are replaced with a pseudonym — see the preview below.",
    explanationCaptionNoDrops:
      "Pseudonymized columns stay in the file, but their values are replaced with a pseudonym — see the preview below.",
    previewHeading: "Preview after de-identification",
    columnsRowsCaption:
      "{{columns}} columns · showing first {{shown}} of {{total}} rows",
    visibleToOnlyYou: "Visible to",
    onlyYou: "only you",
    visibleTo: "Visible to",
    downloadableBy: "downloadable by",
    metadataLabel: {
      projects: "this project",
      org: "your organization",
      private: "no one (hidden)",
    },
    downloadLabel: {
      none: "no one (request required)",
      project: "all project members",
      selected_members: "selected members",
    },
    uploadingButton: "Uploading…",
    uploadAndDeidentifyButton: "Upload and de-identify",
  },
  errors: {
    fileTooLarge: "File size must be less than {{maxMB}} MB",
    readFailed: "Failed to read file",
    previewFailed: "Failed to build preview",
    uploadFailed: "Upload failed",
  },
};

export default importWizard;
